import React from 'react';
import getContent from '../lib/dictionaryFetcher';
import PropTypes from 'prop-types';

const ResultsProductCollapsed = props => {
  const { product, toggleProduct, productName, type } = props,
    collapsedText = getContent('quiz', 'results.collapsed', '', {
      params: { productHeading: product.heading }
    });
  return (
    <div className="results-user-collapsed">
      <p className="results-user-collapsed-text">
        <span dangerouslySetInnerHTML={{ __html: collapsedText }} />{' '}
        <a
          role="button"
          href="#"
          onClick={e => {
            e.preventDefault();
            toggleProduct(productName, false, type);
          }}
        >
          {getContent('quiz', 'results.undo', '')}
        </a>
      </p>
    </div>
  );
};

ResultsProductCollapsed.propTypes = {
  product: PropTypes.object,
  toggleProduct: PropTypes.func,
  productName: PropTypes.string,
  type: PropTypes.string
};

export default ResultsProductCollapsed;
